<form [formGroup]="parent.configuration">
  <header [ngClass]="[parent.configuration.get('isPublic')?.value ? '' : 'unpublished']">
    <inline-editor-lib
      [viewHeader]="parent.isNewConfig ? 'New template ' : 'Editing: '"
      [editHeader]="'Editing: '"
      [allowEdit]="!parent.isNewConfig"
      formControlName="name"
      [showEditIcon]="parent.configuration.get('name').value.length > 0 && !parent.isNewConfig"
      placeholder="e.g. Formatted CV"
      editIconTooltip="Edit template name"
    ></inline-editor-lib>
    <aside>
      @if (showUsageTypesToggle) {
        <mat-button-toggle-group
          [formControl]="parent.usageTypesControl"
          multiple
          hideMultipleSelectionIndicator
          (change)="onUsageTypesChange($event.value)"
          class="small-icons-only black-icon-unselected"
        >
          <mat-button-toggle
            [value]="TemplateUsage.AwesomeDocs"
            matTooltip="For use in Kyloe AwesomeDocs - Create an AwesomeDoc list"
            matTooltipShowDelay="500"
          >
            <mat-icon fontIcon="description" class="material-icons-outlined"></mat-icon>
          </mat-button-toggle>
          <mat-button-toggle
            [value]="TemplateUsage.DocMerge"
            [disabled]="parent.configuration.get('useFileAttachmentAsTemplate')?.value"
            matTooltip="For use in Kyloe DocMerge - Template section"
            matTooltipShowDelay="500"
          >
            <mat-icon fontIcon="merge_type"></mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>
      }
      <mat-slide-toggle
        formControlName="isPublic"
        [matTooltip]="
          parent.configuration.get('isPublic')?.value ? 'Unpublish template' : 'Publish template to all users within your corporation'
        "
        matTooltipShowDelay="500"
      >
        {{ parent.configuration.get('isPublic')?.value ? 'PUBLISHED' : 'UNPUBLISHED' }}
      </mat-slide-toggle>
      @if (parent.canCopyDirectLink) {
        <mat-icon
          fontIcon="link"
          (click)="copyDirectLink.emit()"
          matTooltip="Copy direct link for a Bullhorn Action menu item"
          matTooltipShowDelay="500"
        ></mat-icon>
      }
      @if (!parent.isNewConfig) {
        <mat-icon fontIcon="delete_outline" (click)="delete.emit()" [matTooltip]="'Delete Template'" matTooltipShowDelay="500"></mat-icon>
      }
      <mat-icon fontIcon="close" (click)="discardLocalChanges.emit()" matTooltip="Close" matTooltipShowDelay="500"></mat-icon>
    </aside>
  </header>
</form>
<form [formGroup]="parent.form">
  <mat-tab-group mat-align-tabs="start" dynamicHeight="true" mat-stretch-tabs="false">
    <mat-tab label="Configuration">
      <ng-template mat-tab-label>
        <span [ngClass]="parent.configuration.invalid ? 'invalid-tab' : 'valid-tab'">
          Configuration
          <mat-icon [fontIcon]="parent.validationIconConfiguration" [ngClass]="parent.tabsJustLoaded ? 'first-load' : ''"></mat-icon>
        </span>
      </ng-template>
      <form [formGroup]="parent.configuration" class="workflow-config">
        @if (parent.isNewConfig) {
          <section id="new-template-name" class="template-section grey-background">
            <h3>Template name</h3>
            <input type="text" [formControl]="parent.newTemplateName" placeholder="e.g. Formatted CV" />
          </section>
        }
        <section class="template-section basic-flex-container" [ngClass]="{ 'side-by-side-sections': !parent.isNewConfig }">
          <app-entity-type-picker
            [isNewConfig]="parent.isNewConfig"
            [configuration]="parent.configuration"
            [namespace]="parent.workflowConfig.clientNamespace"
          ></app-entity-type-picker>
          @if (parent.documentDestinationOptionsAllowed) {
            <app-template-availability
              [isNewConfig]="parent.isNewConfig"
              [workflowType]="parent.workflowConfig.workflow"
              [filtersFormArray]="parent.filtersFormArray"
              [configuration]="parent.configuration"
            ></app-template-availability>
          }
        </section>
        <section id="output-file-container" class="template-section">
          <h3>AwesomeDoc (the output file)</h3>
          <section class="output-file-wrapper">
            <app-output-file-name-section [formGroup]="parent.outputFileNameSectionFormGroup"></app-output-file-name-section>
            <app-document-destination-filetype
              [documentDestinationOptionsAllowed]="parent?.documentDestinationOptionsAllowed"
              [outputFileTypeSectionFormGroup]="parent?.outputFileTypeSectionFormGroup"
              [destinationsForOutputFileType]="parent?.destinationsForOutputFileType"
              [fileTypeOptionsAllowed]="parent?.fileTypeOptionsAllowed"
              [entityType]="parent ? parent.configuration.get('entity').value : null"
              [namespace]="parent.workflowConfig.clientNamespace"
              (updateDocumentForDestinationType)="parent.updateDocumentForDestinationType($event, parent.outputFileTypeSectionFormGroup, parent.destinationsForOutputFileType)"
            >
            </app-document-destination-filetype>
            @if (parent.documentDestinationOptionsAllowed) {
              <app-document-destination
                [configuration]="parent.configuration"
                [isNewConfig]="parent.isNewConfig"
              ></app-document-destination>
            }
          </section>
        </section>
        <section class="template-section template-section-toggle">
          <h3>Template file</h3>
          <mat-button-toggle-group
            [formControl]="parent.configuration.get('useFileAttachmentAsTemplate')"
            [hideSingleSelectionIndicator]="true"
          >
            <mat-button-toggle [matTooltip]="'Word file specified in Manager'" matTooltipShowDelay="500" [value]="false">
              Upload template file
            </mat-button-toggle>
            <mat-button-toggle [matTooltip]="'File selected from record'" matTooltipShowDelay="500" [value]="true">
              Use file attachment
            </mat-button-toggle>
          </mat-button-toggle-group>
        </section>
        @if (!parent.configuration.get('useFileAttachmentAsTemplate').value) {
          <div class="side-by-side-sections with-border workflow-section">
            <app-docx-template-section
              class="workflow-section"
              [formGroup]="parent.docxTemplateSectionFormGroup"
              [workflowConfigId]="parent.configuration.get('id').value"
              [templateValid]="parent.templateFilesValid"
              (docxFileNameChange)="onDocxFileNameChange.emit($event)"
            ></app-docx-template-section>
            <app-html-docx-template-section
              class="workflow-section"
              [formGroup]="parent.htmlTemplateSectionFormGroup"
              [workflowConfigId]="parent.configuration.get('id').value"
              [templateValid]="parent.templateFilesValid"
            ></app-html-docx-template-section>
          </div>
        }
        @if (!!parent.entity) {
          <mat-accordion>
            <div class="workflow-section" [ngClass]="SectionType.File">
              <app-attachment-section
                [fileSection]="$any(fileSection)"
                [forceEnabled]="!!parent.configuration.get('useFileAttachmentAsTemplate').value"
                [mergeSection]="$any(mergeSection)"
                [namespace]="parent.workflowConfig.clientNamespace"
                [entityType]="parent.entity"
              ></app-attachment-section>
            </div>
            <div class="workflow-section" [ngClass]="SectionType.Merge">
              <app-merge-section [formGroup]="$any(mergeSection)" [sectionsFormArray]="parent.sectionsFormArray"> </app-merge-section>
            </div>
          </mat-accordion>
        }
      </form>
    </mat-tab>
    @if (parent.showUserRestrictions) {
      <mat-tab>
        <ng-template mat-tab-label>
          <span>
            <mat-icon fontIcon="lock_person" class="tab-icon"></mat-icon>
            Restrictions
          </span>
        </ng-template>
        <app-user-restrictions [filters]="parent.filtersFormArray" [entity]="parent.entity"></app-user-restrictions>
      </mat-tab>
    }
    <mat-tab>
      <ng-template mat-tab-label>
        <span [ngClass]="parent.signatureGroup.invalid ? 'invalid-tab' : 'valid-tab'">
          <mat-icon fontIcon="draw" class="tab-icon"></mat-icon>
          Docusign
          @if (parent.signatureGroup.controls['enabled'].value) {
            <mat-icon
              [fontIcon]="parent.validationIconSignatureGroup"
              [ngClass]="parent.tabsJustLoaded ? 'first-load' : ''"
              [matTooltip]="parent.tooltipText"
              matTooltipShowDelay="500"
            ></mat-icon>
          }
        </span>
      </ng-template>
      <app-docusign-tab
        [formGroup]="parent.signatureGroup"
        [namespace]="parent.workflowConfig.clientNamespace"
        [parent]="parent"
      ></app-docusign-tab>
    </mat-tab>
    <mat-tab label="Scripting Box">
      <ng-template mat-tab-label>
        <span>
          <mat-icon fontIcon="code"></mat-icon>
          Scripting box
        </span>
      </ng-template>
      <app-scripting-box
        [formGroup]="parent.scriptingBoxGroup"
        [clientNamespace]="parent.workflowConfig.clientNamespace"
      ></app-scripting-box>
    </mat-tab>
    @if (showActionsTab) {
      <mat-tab label="Actions">
        <ng-template mat-tab-label>
          <span [ngClass]="parent.actionsGroup.invalid ? 'invalid-tab' : 'valid-tab'">
            <mat-icon fontIcon="lightbulb"></mat-icon>
            Actions
            @if (parent.hasActionsConfigured) {
              <mat-icon
                [fontIcon]="parent.validationIconActionsGroup"
                [ngClass]="parent.tabsJustLoaded ? 'first-load' : ''"
                [matTooltip]="parent.actionsTooltipText"
                matTooltipShowDelay="500"
              ></mat-icon>
            }
          </span>
        </ng-template>
        <app-actions
          [formGroup]="parent.actionsGroup"
          [entity]="parent.entity"
          [isDocusignEnabled]="parent.signatureGroup.get('enabled').value"
        ></app-actions>
      </mat-tab>
    }
  </mat-tab-group>

  <!-- we don't show these because we automatically add one (the max) of each section according to the PM -->
  <!--  <div style="display: flex; gap: 8px; margin-top: 8px;">-->
  <!--    <button type="button" (click)="addTemplateSection()">Add Template Section</button>-->
  <!--    <button type="button" (click)="addOutputFilenameSection()">Add Output Filename</button>-->
  <!--  </div>-->

  <section class="footer-btns">
    <button type="button" class="danger-btn-hover" (click)="discardLocalChanges.emit($event)" tabindex="0" appRipple>cancel</button>
    <button
      type="submit"
      (click)="saveWorkflowConfig.emit()"
      [disabled]="!parent.allowSave"
      [title]="
        parent.allowSave
          ? parent.configuration.get('isPublic')?.value
            ? 'Save template as published (available to all users within your corporation)'
            : 'Save template as unpublished'
          : ''
      "
      tabindex="0"
      appRipple
    >
      <mat-icon>{{ parent.configuration.get('isPublic')?.value ? 'public' : 'public_off' }}</mat-icon>
      save as {{ parent.configuration.get('isPublic')?.value ? 'PUBLISHED' : 'UNPUBLISHED' }}
      <mat-icon class="watermark">{{ parent.configuration.get('isPublic')?.value ? 'public' : 'public_off' }}</mat-icon>
    </button>
  </section>

  <!--  <pre style="margin-top:20px;"><span style="color: white; background-color: slategray;">{{form.value | json}} | valid={{form.valid}}, dirty={{form.dirty}}</span></pre>-->
</form>
